import { render, staticRenderFns } from "./selectedDormDialog.vue?vue&type=template&id=1a557c65&scoped=true"
import script from "./selectedDormDialog.vue?vue&type=script&lang=js"
export * from "./selectedDormDialog.vue?vue&type=script&lang=js"
import style0 from "./selectedDormDialog.vue?vue&type=style&index=0&id=1a557c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a557c65",
  null
  
)

export default component.exports